import toolAssets from '../shared/classic-tools.json';
import { assetUrl } from './hd-assets';

/** Original menu artwork is reused at its native aspect ratio, without repainting. */
export const classicToolsAssetPaths = Object.values(toolAssets.assets).map(asset => asset.path);

export function classicTools(muted: boolean): string {
  const atlas = toolAssets.assets.menuButtons;
  const style = (icon: keyof typeof atlas.buttons) => {
    const rect = atlas.buttons[icon];
    return `--tool-art-x:${-rect.x / 2}px;--tool-art-y:${-rect.y / 2}px`;
  };
  const button = (id: string, label: string, title: string, icon: keyof typeof atlas.buttons, hidden = false) =>
    `<button id="${id}" type="button" class="classic-tool${hidden ? ' hidden' : ''}" title="${title}" aria-label="${title}" style="${style(icon)}">${label}</button>`;
  return `<div class="stage-tools classic-tools" role="toolbar" aria-label="游戏操作" style="--tool-atlas:url('${assetUrl(atlas.path)}');--tool-atlas-width:${atlas.width / 2}px;--tool-atlas-height:${atlas.height / 2}px">
    <span id="connection" class="connection offline" role="status" aria-label="尚未入房" title="尚未入房">尚未入房</span>
    ${button('leave-room', '退出', '退出房间', 'back', true)}
    ${button('end-battle', '返回', '返回房间', 'back', true)}
    ${button('invite', '邀请', '邀请', 'invite')}
    <button id="sound" type="button" class="classic-tool${muted ? ' muted' : ''}" title="${muted ? '开启声音' : '关闭声音'}" aria-label="${muted ? '开启声音' : '关闭声音'}" aria-pressed="${!muted}" style="${style('sound')}">声音</button>
    ${button('help', '帮助', '帮助', 'help')}
    ${button('about', '资料', '资料', 'info')}
  </div>`;
}
